import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/bcp/plans/crisis-comm')({
  beforeLoad: () => {
    // TanStack Router expects redirect to be thrown as control flow.
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({
      to: '/bcp/plans',
      search: {
        section: 'communication_plan',
      },
      replace: true,
    });
  },
  component: () => null,
});
